import {fetchAuthorized} from "@atg-shared/auth";
import {getLanguage} from "@atg-shared/language";

export const launchUrl = `/services/tokenized/kambi/api/v3/launch`;

export type Client = "atgapp";

type AuthCodeData = {
    currencyCode: string;
    launchData: string;
    locale: string;
    playerMarket: string;
};

export const fetchAuthCode = (
    {client}: {client?: Client | null | undefined} = {client: null},
) => {
    const lang = getLanguage();

    return fetchAuthorized<AuthCodeData>(
        client
            ? `${launchUrl}?${new URLSearchParams({
                  client,
                  locale: lang.locale,
              }).toString()}`
            : `${launchUrl}?locale=${lang.locale}`,
        {method: "GET"},
        {memberFlowEnabled: false},
    );
};
